import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {Box, Typography} from '@mui/material';

export interface BreakdownPoint {
  key: string;
  count: number;
}

interface Props {
  data: BreakdownPoint[];
  emptyLabel?: string;
  color?: string;
}

export default function PilotBreakdownChart({data, emptyLabel, color}: Props) {
  if (!data || data.length === 0) {
    return (
      <Box
        sx={{
          height: 240,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'text.secondary',
          fontSize: 13,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {emptyLabel || 'No data in this range yet.'}
        </Typography>
      </Box>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{top: 8, right: 24, bottom: 0, left: 16}}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
        <XAxis type="number" tick={{fontSize: 12}} allowDecimals={false} />
        <YAxis
          dataKey="key"
          type="category"
          tick={{fontSize: 12}}
          width={150}
        />
        <Tooltip
          contentStyle={{
            fontSize: 12,
            borderRadius: 8,
            border: '1px solid rgba(0,0,0,0.08)',
          }}
        />
        <Bar
          dataKey="count"
          fill={color || '#5f7a32'}
          radius={[0, 4, 4, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
